import {
	toParams,
	fromParamMap,
} from 'src/admin-app/utilities/list-filtering/shared';
import { JobListArgs, SortCriterion } from 'src/shared/api';
import {
	toTextFilterParams,
	toCustomerParams,
	toStartDateParams,
	toTextFilterListArgs,
	toCustomerListArgs,
	toStartDateListArgs,
	toPagingParams,
	toSortingParams,
	toPagingListArgs,
	toSortingListArgs,
	toQuoteStatusParams,
	toQuoteStatusListArgs,
	toTeamParams,
	toTeamListArgs,
} from 'src/admin-app/utilities/list-filtering/mappers';
import * as moment from 'moment';
import { momentBuilderFactory } from 'src/shared/utilities/utility-functions';
import { Override } from 'src/admin-app/utilities/utility-types';

export const convertToQuotesParams = toParams<JobListArgs>(
	toTextFilterParams,
	toPagingParams,
	toSortingParams,
	toTeamParams,
	toCustomerParams,
	toStartDateParams,
	toQuoteStatusParams
);

export const convertToQuotesListArgs = fromParamMap<JobListArgs>(
	toTextFilterListArgs,
	toPagingListArgs,
	toSortingListArgs,
	toTeamListArgs,
	toCustomerListArgs,
	toStartDateListArgs,
	toQuoteStatusListArgs
);

export const makeDatesMoments = momentBuilderFactory<
	JobListArgs,
	QuoteListFilters
>('startDate');

export type QuoteListFilters = Omit<
	Override<JobListArgs, { startDate?: string | moment.Moment }>,
	keyof {
		sortCriteria?: SortCriterion[];
		pageSize: number;
		pageNumber: number;
		serviceTypeId?: number;
	}
>;
